import { createSlice, createAction } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface Customer {
  id: string;
  restaurantId: string;
  type: string;
  name: string;
  phone: string;
  email: string;
  address: {
    address: string;
    city: string;
    state: string;
    country: string;
    zipcode: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CustomersState {
  data: Customer[];
  loading: boolean;
  error: string | null;
}

const initialState: CustomersState = {
  data: [],
  loading: false,
  error: null,
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    fetchCustomersRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchCustomersSuccess: (state, action: PayloadAction<Customer[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchCustomersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCustomers: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
  },
});

// Add customer actions
export const addCustomerRequest = createAction<{ restaurantId: string; customerData: any }>('customers/addCustomerRequest');
export const addCustomerSuccess = createAction('customers/addCustomerSuccess');
export const addCustomerFailure = createAction<string>('customers/addCustomerFailure');

// Upload customers actions
export const uploadCustomersRequest = createAction<{ restaurantId: string; file: File }>('customers/uploadCustomersRequest');
export const uploadCustomersSuccess = createAction('customers/uploadCustomersSuccess');
export const uploadCustomersFailure = createAction<string>('customers/uploadCustomersFailure');

export const {
  fetchCustomersRequest,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  clearCustomers,
} = customersSlice.actions;

export default customersSlice.reducer;
